import { StyledTooltip } from "@/components/StyledTooltip/StyledTooltip";
import { Box, Checkbox, Typography } from "@mui/material";
import React from "react";

type LabelledCheckboxProps = {
  label: string;
  checked: boolean;
  tooltip?: React.ReactNode;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const LabelledCheckbox: React.FC<LabelledCheckboxProps> = ({ label, checked, disabled, onChange, tooltip }) => {
  return (
    <StyledTooltip placement="right" title={tooltip}>
      <Box sx={{ display: "flex", justifyContent: "flex-start", width: "fit-content", gap: "8px", height: "fit-content" }}>
        {/* Label */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "18px",
              width: "180px",
              height: "22px"
            }}
          >
            {label}
          </Typography>
        </Box>

        {/* Checkbox */}
        <Checkbox size="medium" checked={checked} disabled={disabled} onChange={onChange} />
      </Box>
    </StyledTooltip>
  );
};
